export const en = {
  'yandex': 'YANDEX',
  'org': '{link} LLC',
  'docs': 'Documentation',
}
